import React, { useEffect, useState } from "react";

import ReactPaginate from "react-paginate";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import SearchEmpty from "components/SearchEmpty";

import {
  ContainerList,
  ListItems,
  ListPagination,
} from "./styles";
import backArrow from "../../../assets/svg/bx-arrow-back.svg";

export interface IReactPaginate {
  list: React.ReactNode | React.ReactNode[];
  title: string;
  height?: string;
  onChangePage: (page: number) => void;
  loading: boolean;
  serverSidePagination?: boolean;
  serverPageCount?: number;
  serverCurrentPage?: number;
}

export const ReactPaginateKenta = ({
  list,
  title,
  height,
  onChangePage,
  loading,
  serverSidePagination = false,
  serverPageCount = 0,
  serverCurrentPage = 0,
}: IReactPaginate) => {
  const { t } = useTranslation();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [valeuRegisterPerPage, setValeuRegisterPerPage] = useState<number>(10);
  const [previousLabel, setPreviousLabel] = useState<React.ReactNode>(
    <Arrow rotated={false} />,
  );
  const [nextLabel, setNextLabel] = useState<React.ReactNode>(
    <Arrow rotated={true} />,
  );
  const { globalConfigurations } = useSelector(
    (state: any) => state.configurations,
  );

  const activePage = serverSidePagination ? serverCurrentPage : currentPage;

  const offset = currentPage * valeuRegisterPerPage;
  let currentPageData: React.ReactNode[] = [];
  if (serverSidePagination) {
    currentPageData = Array.isArray(list) ? list : [];
  } else if (Array.isArray(list)) {
    currentPageData = list.slice(offset, offset + valeuRegisterPerPage);
  }

  const pageCount: number = serverSidePagination
    ? serverPageCount
    : Math.ceil(
        (Array.isArray(list) ? list : []).length / valeuRegisterPerPage,
      );

  useEffect(() => {
    (async () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }

      if (!serverSidePagination) {
        const paginationList = Array.isArray(globalConfigurations)
          ? globalConfigurations?.find(
              (x: any) => x?.name === "PaginationList",
            )
          : [];

        const paginationLocal = paginationList?.value || "5";

        paginationLocal !== null
          ? setValeuRegisterPerPage(parseInt(paginationLocal))
          : setValeuRegisterPerPage(10);
      }

      if (pageCount === 1) {
        setPreviousLabel("");
        setNextLabel("");
      }
    })();
  }, []);

  useEffect(() => {
    if (pageCount === 0) {
      setPreviousLabel("");
      setNextLabel("");
    } else {
      if (pageCount > 1) {
        if (activePage === 0) {
          setPreviousLabel("");
        } else {
          setPreviousLabel(<Arrow rotated={false} />);
        }
        if (activePage >= pageCount - 1) {
          setNextLabel("");
        } else {
          setNextLabel(<Arrow rotated={true} />);
        }
      } else {
        setPreviousLabel("");
        setNextLabel("");
      }
    }
  }, [pageCount, activePage]);

  function handlePageClick(selectedPage: number) {
    if (!serverSidePagination) {
      setCurrentPage(selectedPage);
    }
    formartPreviousLabel(selectedPage);
    formartNextLabel(selectedPage);
    onChangePage(selectedPage);
  }

  function formartPreviousLabel(selectedPage: number) {
    if (selectedPage === 0) {
      setPreviousLabel("");
    } else {
      setPreviousLabel(<Arrow rotated={false} />);
    }
  }

  function formartNextLabel(selectedPage: number) {
    const lastPage = selectedPage + 1;
    if (lastPage === pageCount) {
      setNextLabel("");
    } else {
      setNextLabel(<Arrow rotated={true} />);
    }
  }

  useEffect(() => {
    if (serverSidePagination) return;

    const pageCount = Math.ceil(
      (Array.isArray(list) ? list.length : 0) / valeuRegisterPerPage,
    );

    if (currentPage >= pageCount - 1 && pageCount > 0) {
      const lastPage = pageCount - 1;
      setCurrentPage(lastPage);
      onChangePage(lastPage);
    }
  }, [list, currentPage, onChangePage, valeuRegisterPerPage]);

  return (
    <>
      <ContainerList height={height}>
        {Array.isArray(list) && list.length > 0 ? (
          <div>
            <ListItems>
              <div data-cy="menuDivList" className="menudivList">
                {currentPageData}
              </div>
            </ListItems>
          </div>
        ) : !loading ? (
          <SearchEmpty textMessage={t("common.noResults")} typeIcon={"file"} />
        ) : null}
      </ContainerList>

      <div>
        {pageCount > 1 && (
          <ListPagination>
            <ReactPaginate
              previousLabel={previousLabel}
              nextLabel={nextLabel}
              pageCount={pageCount > 1 ? pageCount : 0}
              forcePage={activePage}
              onPageChange={(e: any) => handlePageClick(e.selected)}
              containerClassName={"pagination"}
              previousLinkClassName={
                previousLabel !== ""
                  ? "pagination__link"
                  : "previusAndNextDisableCursor"
              }
              nextLinkClassName={
                nextLabel !== ""
                  ? "pagination__link"
                  : "previusAndNextDisableCursor"
              }
              disabledClassName={"pagination__link--disabled"}
              activeClassName={"pagination__link--active"}
            />
          </ListPagination>
        )}
      </div>
    </>
  );
};

interface ArrowProps {
  rotated: boolean;
}

export const Arrow: React.FC<ArrowProps> = ({ rotated }) => {
  return (
    <>
      {rotated ? (
        <img
          style={{
            transform: "rotate(180deg)",
          }}
          src={backArrow}
          alt=""
        />
      ) : (
        <img src={backArrow} alt="" />
      )}
    </>
  );
};
